import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-types-importer',
  templateUrl: './asset-types-importer.component.html',
  styleUrls: ['./asset-types-importer.component.scss']
})
export class AssetTypesImporterComponent {

}
